import { combineReducers } from 'redux';

import attachments from '../attachments/reducers';
import auditTrailFile from '../auditTrailFile/reducers';
import data from '../data/reducers';
import file from '../file/reducers';
import { reducer as renderTree } from '../renderTree';
import isSendingToEmail from './isSendingToEmail';

export default combineReducers({
  attachments,
  auditTrailFile,
  data,
  file,
  isSendingToEmail,
  renderTree,
});
